import { createSlice } from "@reduxjs/toolkit";
import {
  viewTeams
} from "../actions/teamsAction";

const newsSlice = createSlice({
  name: "teams",
  initialState: {
    teams: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(viewTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(viewTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
